import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { COLORS, SIZING } from '../../../styles/variables';
import { device } from '../../../styles/devices';

interface StyleProps {
  checked?: boolean;
  disabled?: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 32px;
  margin-top: 8px;
  @media ${device.tablet} {
    padding-top: 24px;
  }
  @media ${device.laptop} {
    padding-top: 32px;
    margin-top: 8px;
  }
`;

export const LabelInput = styled.h4`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
`;

export const Title = styled.div`
  font-family: Audi Type;
  font-size: 12px;
  line-height: 20px;
  color: ${COLORS.grey60};
  margin: 0 0 ${SIZING.unit(1.5)} 0;
  align-self: flex-start;
  letter-spacing: 0.002px;
  @media ${device.laptopL} {
    font-size: 12px;
    line-height: 20px;
  }
`;

export const ButtonList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 16px;
  gap: 24px;
  flex-grow: 1;
  @media ${device.tablet} {
  }
  @media ${device.laptop} {
    flex-direction: row;
    align-items: center;
    gap: 48px;
  }
`;

export const RadioButton = styled.li`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const RadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0;
  flex: 0 0 50%;
  cursor: pointer;

  ${({ disabled }: StyleProps) =>
    disabled === true &&
    `pointer-events: none;
       opacity: 0.2;
      `}

  @media ${device.laptopL} {
    flex: 0 0 33%;
    margin-right: ${SIZING.unit(4)};
  }
`;

export const Count = styled.div`
  margin-left: ${SIZING.unit(1)};
  color: ${COLORS.grey60};
`;

export const Radio = styled.div`
  cursor: pointer;
  min-width: 20px;
  height: 20px;
  border: ${({ checked }: StyleProps) =>
    checked ? `1px solid ${COLORS.grey80}` : `1px solid ${COLORS.grey60}`};
  border-radius: 100%;
  /* margin: 0 ${SIZING.unit(1.5)} 0 0; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.label`
  display: inline-flex;
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.grey80};
  letter-spacing: 0.003px;
`;

export const HiddenInput = styled.input`
  display: none;
`;
